import LocaleSwitcher from 'Components/Organisms/LocaleSwitcher/LocaleSwitcher';

export default function AuthLayoutLocaleSwitcher() {
    return (
        <div className="fixed bottom-3 left-3 md:bottom-auto md:left-auto md:right-3 md:top-3">
            <LocaleSwitcher />
        </div>
    );
}
